import { render, staticRenderFns } from "./ListRequestTypeCard.vue?vue&type=template&id=cc4b4756&scoped=true&"
import script from "./ListRequestTypeCard.vue?vue&type=script&lang=js&"
export * from "./ListRequestTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./ListRequestTypeCard.vue?vue&type=style&index=0&id=cc4b4756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4b4756",
  null
  
)

export default component.exports